import { useTranslation } from 'react-i18next';
import { book } from '../content/book.js';

const ICONS = {
  instagram: (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className="w-full h-full">
      <rect x="3.5" y="3.5" width="17" height="17" rx="4.5" fill="none" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="12" cy="12" r="3.7" fill="none" stroke="currentColor" strokeWidth="1.25" />
      <circle cx="17.1" cy="6.9" r="0.85" fill="currentColor" />
    </svg>
  ),
  facebook: (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className="w-full h-full">
      <path
        d="M13.6 21V13.4h2.6l.4-3h-3V8.5c0-.86.24-1.45 1.5-1.45h1.6V4.4c-.28-.04-1.23-.12-2.34-.12-2.31 0-3.9 1.4-3.9 3.97v2.16H7.8v3h2.66V21h3.14z"
        fill="currentColor"
      />
    </svg>
  ),
  goodreads: (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" className="w-full h-full">
      <path
        d="M14.6 18.55c-.03 1.27-.6 2.27-1.7 3.02-1.1.74-2.45 1.07-4.04 1-1.43-.05-2.66-.42-3.7-1.1-1.04-.7-1.7-1.78-1.97-3.27h2.3c.27.84.74 1.45 1.4 1.83.66.39 1.4.55 2.22.5 1.04-.06 1.85-.43 2.43-1.1.58-.69.85-1.6.83-2.74V14.7h-.06c-.43.84-1.06 1.5-1.88 1.96a5.55 5.55 0 0 1-2.74.7c-1.18 0-2.22-.27-3.13-.83a5.7 5.7 0 0 1-2.1-2.27 7.15 7.15 0 0 1-.74-3.32c0-1.27.25-2.4.74-3.41a5.7 5.7 0 0 1 2.13-2.36 5.7 5.7 0 0 1 3.16-.85c1.04 0 1.96.24 2.77.72.81.48 1.42 1.12 1.83 1.93h.04V5.42h2.21V18.55zm-5.62-3.31c.84 0 1.55-.2 2.13-.6.58-.4 1.02-.96 1.32-1.66.3-.7.46-1.5.46-2.4 0-.93-.15-1.74-.46-2.43a3.7 3.7 0 0 0-1.32-1.66 3.5 3.5 0 0 0-2.06-.6c-.84 0-1.55.2-2.13.6a3.84 3.84 0 0 0-1.34 1.66c-.3.69-.46 1.5-.46 2.43 0 .9.16 1.7.46 2.4.31.7.76 1.26 1.34 1.66a3.7 3.7 0 0 0 2.06.6z"
        fill="currentColor"
      />
    </svg>
  ),
};

export default function SocialIcons({ size = 'md', tone = 'silver' }) {
  const { t } = useTranslation();
  const sizes = {
    sm: 'w-4 h-4',
    md: 'w-[18px] h-[18px]',
    lg: 'w-5 h-5',
  };
  const tones = {
    silver: 'text-silver-400 hover:text-silver-50',
    burgundy: 'text-silver-300 hover:text-burgundy-100',
  };
  return (
    <ul className="flex items-center gap-5" aria-label={t('footer.follow')}>
      {book.social.map((s) => (
        <li key={s.id}>
          <a
            href={s.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className={`${tones[tone] || tones.silver} transition-colors duration-300 ease-out-quart inline-block ${sizes[size]}`}
          >
            {ICONS[s.id]}
          </a>
        </li>
      ))}
    </ul>
  );
}
